const convertShadowsToCSS = (shadows) => ({
    '--shadows-tint-1-x': `${shadows.tint1.x}px`,
    '--shadows-tint-1-y': `${shadows.tint1.y}px`,
    '--shadows-tint-1-blur': `${shadows.tint1.blur}px`,
    '--shadows-tint-1-spread': `${shadows.tint1.spread}px`,
    '--shadows-tint-1-color': shadows.tint1.color,
    '--shadows-tint-2-x': `${shadows.tint2.x}px`,
    '--shadows-tint-2-y': `${shadows.tint2.y}px`,
    '--shadows-tint-2-blur': `${shadows.tint2.blur}px`,
    '--shadows-tint-2-spread': `${shadows.tint2.spread}px`,
    '--shadows-tint-2-color': shadows.tint2.color,
    '--shadows-tint-3-x': `${shadows.tint3.x}px`,
    '--shadows-tint-3-y': `${shadows.tint3.y}px`,
    '--shadows-tint-3-blur': `${shadows.tint3.blur}px`,
    '--shadows-tint-3-spread': `${shadows.tint3.spread}px`,
    '--shadows-tint-3-color': shadows.tint3.color,
});
const convertShadowsToObject = (shadows) => ({
    shadowsTint1: shadows.tint1,
    shadowsTint2: shadows.tint2,
    shadowsTint3: shadows.tint3,
});
const Shadows = {
    tint1: {
        x: 'var(--shadows-tint-1-x)',
        y: 'var(--shadows-tint-1-y)',
        blur: 'var(--shadows-tint-1-blur)',
        spread: 'var(--shadows-tint-1-spread)',
        color: 'var(--shadows-tint-1-color)',
    },
    tint2: {
        x: 'var(--shadows-tint-2-x)',
        y: 'var(--shadows-tint-2-y)',
        blur: 'var(--shadows-tint-2-blur)',
        spread: 'var(--shadows-tint-2-spread)',
        color: 'var(--shadows-tint-2-color)',
    },
    tint3: {
        x: 'var(--shadows-tint-3-x)',
        y: 'var(--shadows-tint-3-y)',
        blur: 'var(--shadows-tint-3-blur)',
        spread: 'var(--shadows-tint-3-spread)',
        color: 'var(--shadows-tint-3-color)',
    },
};

export { Shadows, convertShadowsToCSS, convertShadowsToObject };
